<template>
  <div v-if="timeLeft > 0"
    class="countdown-timer">
    <div>
      <p><span class="subject mr-1">Expired In:</span> {{ paddedHours }}h, {{ paddedMinutes }}m, {{ paddedSeconds }}s</p>
    </div>
  </div>
  <div v-else
    class="countdown-timer">
    <p class="title">Time's up!</p>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'CountDownTimer',
  props: {
    targetDateTime: {
      type: DateTime,
      required: true
    }
  },
  data() {
    return {
      timeLeft: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },
  computed: {
    paddedHours() {
      return this.hours.toString().padStart(2, '0')
    },
    paddedMinutes() {
      return this.minutes.toString().padStart(2, '0')
    },
    paddedSeconds() {
      return this.seconds.toString().padStart(2, '0')
    }
  },
  created() {
    this.calculateTimeLeft()
    this.timer = setInterval(this.calculateTimeLeft, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    calculateTimeLeft() {
      const now = new Date()
      const target = new Date(this.targetDateTime)
      const difference = target - now

      if (difference > 0) {
        this.timeLeft = difference
        this.hours = Math.floor(difference / (1000 * 60 * 60))
        this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
        this.seconds = Math.floor((difference % (1000 * 60)) / 1000)
      } else {
        this.timeLeft = 0
        this.$emit('count-down-timeout') // Emit event to parent
        clearInterval(this.timer) // Stop the timer when time is up
      }
    }
  }
}
</script>

<style scoped>
.subject {
   color: #000;
}
.countdown-timer {
  /* max-width: 400px; */
  /* margin: 0 auto; */
  font-size: 0.5rem;
  color: #3273dc; /* Bulma primary color */
}
.countdown-timer p {
   font-size: 1.01rem;
   font-weight: bold;
}
</style>

